import { Trans } from 'react-i18next';

import { EMainRoutes } from 'shared/typings';
import { Link } from 'shared/ui';

import { NotificationOffer, NotificationSource } from '../api/codegen.api';
import { ENotificationTypes, INotificationType, TExtraValue } from '../model/types';

export const NOTIFICATIONS_TYPES: { [key: string]: INotificationType } = {
	[ENotificationTypes.SOURCE_REJECTED]: {
		text: ({ name, slug }: NotificationOffer, source: NotificationSource, extra: TExtraValue = ['']) => {
			const [comment] = extra;

			return (
				<Trans i18nKey="notificationDescRejected">
					{{ source: source.name }} has been rejected for{' '}
					<Link to={`/${EMainRoutes.CATALOG}/${EMainRoutes.OFFER}/${slug}`}>{{ name }}</Link>. Comment:{' '}
					{{ comment: comment || '' }}. Please review the feedback and feel free to adjust your sources accordingly.
				</Trans>
			);
		},
		title: (offer: NotificationOffer) => (
			<Trans i18nKey="notificationTitleRejected">
				Your application for offer {{ offer: offer.name }} has been rejected.
			</Trans>
		),
		extra: ['rejection_comment'],
	},

	[ENotificationTypes.SOURCE_DISCONNECTED]: {
		text: ({ name, slug }: NotificationOffer, source: NotificationSource, extra: TExtraValue = ['']) => {
			const [comment] = extra;

			return (
				<Trans i18nKey="notificationDescDisconnected">
					The connection of {{ source: source.name }} with{' '}
					<Link to={`/${EMainRoutes.CATALOG}/${EMainRoutes.OFFER}/${slug}`}>{{ name }}</Link> has been stopped. Comment:{' '}
					{{ comment: comment || '' }}. Please review the feedback or contact support for further assistance.
				</Trans>
			);
		},
		title: (offer: NotificationOffer, source: NotificationSource) => (
			<Trans i18nKey="notificationTitleDisconnected">
				The connection of {{ source: source.name }} with {{ offer: offer.name }} has been stopped.
			</Trans>
		),
		extra: ['rejection_comment'],
	},

	[ENotificationTypes.SOURCE_JOINED]: {
		text: ({ name, slug }: NotificationOffer, source: NotificationSource, extra: TExtraValue = ['', '']) => {
			const [cap, mmpLink] = extra;

			return (
				<Trans i18nKey="notificationDescJoined">
					Congratulations! {{ source: source.name }} has successfully joined{' '}
					<Link to={`/${EMainRoutes.CATALOG}/${EMainRoutes.OFFER}/${slug}`}>{{ name }}</Link>. Cap: {{ cap: cap || '' }}
					. Access the offer MMP link{' '}
					<Link href={mmpLink} target="_blank">
						here
					</Link>
					. Welcome aboard!
				</Trans>
			);
		},
		title: (offer: NotificationOffer) => (
			<Trans i18nKey="notificationTitleJoined">
				Your application for offer {{ offer: offer.name }} has been joined.
			</Trans>
		),
		extra: ['cap', 'mmp_link'],
	},

	[ENotificationTypes.SOURCE_RECIEVED]: {
		text: ({ name, slug }: NotificationOffer, source: NotificationSource) => {
			return (
				<Trans i18nKey="notificationDescReceived">
					Your application for the <Link to={`/${EMainRoutes.CATALOG}/${EMainRoutes.OFFER}/${slug}`}>{{ name }}</Link>{' '}
					has been received. The source {{ source: source.name }} you submitted is currently under moderation for this
					offer.
				</Trans>
			);
		},
		title: (offer: NotificationOffer) => (
			<Trans i18nKey="notificationTitleReceived">
				Your application for offer {{ offer: offer.name }} has been received.
			</Trans>
		),
		extra: [''],
	},

	[ENotificationTypes.CAP_ASSIGNED]: {
		text: ({ name, slug }: NotificationOffer, source: NotificationSource) => (
			<Trans i18nKey="notificationDescAssigned">
				A new cap has been assigned to {{ source: source.name }} on{' '}
				<Link to={`/${EMainRoutes.CATALOG}/${EMainRoutes.OFFER}/${slug}`}>{{ name }}</Link>. Please check the details
				and adjust your strategies accordingly
			</Trans>
		),
		title: (offer: NotificationOffer, source: NotificationSource) => (
			<Trans i18nKey="notificationTitleAssigned">
				A new cap has been assigned to source {{ source: source.name }} on {{ offer: offer.name }}.
			</Trans>
		),
		extra: [''],
	},

	[ENotificationTypes.LINK_UPDATED]: {
		text: ({ name, slug }: NotificationOffer, source: NotificationSource) => (
			<Trans i18nKey="notificationDescUpdated">
				The MMP link for {{ source: source.name }} on{' '}
				<Link to={`/${EMainRoutes.CATALOG}/${EMainRoutes.OFFER}/${slug}`}>{{ name }}</Link> has been updated. Please
				ensure your systems are configured with the new link to maintain tracking accuracy.
			</Trans>
		),
		title: (offer: NotificationOffer, source: NotificationSource) => (
			<Trans i18nKey="notificationTitleUpdated">
				The MMP link for {{ source: source.name }} on {{ offer: offer.name }} has been updated.
			</Trans>
		),
		extra: [''],
	},

	[ENotificationTypes.CUSTOM]: {
		text: () => '',
		title: () => '',
		extra: [''],
	},
};
